import { render } from "./flvjsPlayer.vue?vue&type=template&id=07a40da4&scoped=true"
import script from "./flvjsPlayer.vue?vue&type=script&lang=js"
export * from "./flvjsPlayer.vue?vue&type=script&lang=js"

import "./flvjsPlayer.vue?vue&type=style&index=0&id=07a40da4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a40da4"]])

export default __exports__